import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { TrackerLayout } from './TrackerLayout';
import { PostList } from './PostList';
import { trackerGet, CARD, TIER_ORDER, TYPE_LABEL, errMsg } from './trackerApi';

const Chip = ({ active, onClick, children, testid }) => (
  <button onClick={onClick} className={`px-3 py-1.5 rounded-full text-xs font-medium border transition-colors ${active ? 'bg-[#FF451A] border-[#FF451A] text-white' : 'border-black/[0.1] text-[#3F3F46] hover:border-[#FF451A]/50'}`} data-testid={testid}>{children}</button>
);

const Group = ({ label, options, value, onChange, testid }) => (
  <div className="flex items-center gap-1.5 flex-wrap">
    <span className="text-[11px] font-semibold uppercase tracking-wider text-[#A1A1AA] mr-1">{label}</span>
    <Chip active={!value} onClick={() => onChange(null)} testid={`${testid}-all`}>All</Chip>
    {options.map(([v, l]) => <Chip key={v} active={value === v} onClick={() => onChange(v)} testid={`${testid}-${String(v).toLowerCase()}`}>{l}</Chip>)}
  </div>
);

const Feed = () => {
  const [f, setF] = useState({ competitor: null, post_type: null, tier: null, paid: null });
  const [d, setD] = useState(null);
  useEffect(() => {
    let stale = false;
    const params = Object.fromEntries(Object.entries(f).filter(([, v]) => v !== null));
    trackerGet('/posts', params).then((x) => !stale && setD(x)).catch((e) => !stale && setD((p) => ({ ...(p || { competitors: [], window_days: 30 }), posts: [], error: errMsg(e, 'Could not load posts') })));
    return () => { stale = true; };
  }, [f]);
  const set = (k) => (v) => setF((x) => ({ ...x, [k]: v }));
  return (
    <div className={`${CARD} p-6 space-y-5`}>
      <div className="space-y-2.5" data-testid="tracker-filters">
        <Group label="Brand" options={(d?.competitors || []).map((c) => [c.instagram_handle, c.name])} value={f.competitor} onChange={set('competitor')} testid="tracker-filter-competitor" />
        <Group label="Type" options={Object.entries(TYPE_LABEL)} value={f.post_type} onChange={set('post_type')} testid="tracker-filter-type" />
        <Group label="Tier" options={TIER_ORDER.map((t) => [t, t])} value={f.tier} onChange={set('tier')} testid="tracker-filter-tier" />
        <Group label="Collab" options={[[true, 'Paid'], [false, 'Organic']]} value={f.paid} onChange={set('paid')} testid="tracker-filter-paid" />
      </div>
      {!d ? <Loader2 className="animate-spin text-[#FF451A]" size={18} /> : (
        <>
          <div className="text-xs text-[#71717A]" data-testid="tracker-count">{d.error || `${d.posts.length} posts · last ${d.window_days} days`}</div>
          <PostList posts={d.posts} showCompetitor testid="tracker-feed" />
        </>
      )}
    </div>
  );
};

export default function CompetitorTracker() {
  return (
    <TrackerLayout title="Tracker" subtitle="Every competitor creator post in one feed. Filter by brand, format, creator tier or paid collabs.">
      {() => <Feed />}
    </TrackerLayout>
  );
}
